var map = {
	"./mvc/index.tsx": [
		5815,
		815
	],
	"./svc/index.tsx": [
		2749,
		749
	],
	"./tmvcs/index.tsx": [
		8848,
		848
	],
	"./wvc/index.tsx": [
		8969,
		969
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8248;
module.exports = webpackAsyncContext;